module.exports = __webpack_public_path__ + "static/media/anatomia2.b27b76a4.png";